import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FlexSpinnerComponent} from "./flex-spinner.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";



@NgModule({
  declarations: [FlexSpinnerComponent],
  exports: [
    FlexSpinnerComponent
  ],
    imports: [
        CommonModule,
        MatProgressSpinnerModule
    ]
})
export class FlexSpinnerModule { }
